document.addEventListener('DOMContentLoaded', function () {
  let addToCartButton = document.getElementById('schema-add-to-cart-btn');
  const checkboxes = document.querySelectorAll('.bundle-checkbox');
  const selectAllButton = document.getElementById('select-all-button');
  const singleAddToCartButtons = document.querySelectorAll('.add-to-cart-single');
  const cartDrawer = document.querySelector('cart-drawer');

  function updateSelectAllButtonText() {
  if (!selectAllButton) return; // prevent null error
  const anyChecked = Array.from(checkboxes).some(cb => cb.checked && !cb.disabled);
  selectAllButton.textContent = anyChecked ? 'Deselect All' : 'Select All';
}


  function updateAddToCartButton() {
    const anyChecked = Array.from(checkboxes).some(cb => cb.checked && !cb.disabled);
    if (addToCartButton) {
      addToCartButton.style.display = anyChecked ? 'flex' : 'none';
    }
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
          .then(res => res.json())
          .then(sections => {
            if (typeof cartDrawer?.renderContents === 'function') {
              cartDrawer.renderContents({
                id: cartData.token,
                sections,
                item_count: cartData.item_count
              });
            } else {
              cartDrawer?.classList.add('active');
              cartDrawer?.style.setProperty('visibility', 'visible');
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData } }));
          });
      })
      .catch(err => console.error('Error refreshing cart drawer:', err));
  }

  function updateBasketCounts() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.schema-product-row').forEach(row => {
          const checkbox = row.querySelector('.bundle-checkbox');
          const badge = row.querySelector('.rr--schema-cart-count span');
          const item = cart.items.find(i => i.variant_id == checkbox.dataset.variantId);
          badge.textContent = item ? `${item.quantity} in Basket` : '';
        });
      });
  }

  function extractItemData(checkbox) {
    const row = checkbox.closest('.schema-product-row');
    const qtyInput = row?.querySelector('.rr--quantity__input');
    let quantity = parseInt(qtyInput?.value?.trim(), 10);
    return {
      id: parseInt(checkbox.dataset.variantId),
      quantity: !isNaN(quantity) && quantity > 0 ? quantity : 1
    };
  }

  function addProductsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
  }

  function handleSingleAdd(button) {
    const checkbox = button.closest('.schema-product-row').querySelector('.bundle-checkbox');
    const item = extractItemData(checkbox);
    setTimeout(() => {
      addProductsToCart([item]).then(() => {
        refreshCartDrawer();
        updateBasketCounts();
      });
    }, 10);
  }

  function handleGroupAdd() {
    const selectedItems = Array.from(checkboxes)
      .filter(cb => cb.checked && !cb.disabled)
      .map(cb => extractItemData(cb));

    if (!selectedItems.length) return;

    setTimeout(() => {
      addProductsToCart(selectedItems).then(() => {
        refreshCartDrawer();
        updateBasketCounts();
        checkboxes.forEach(cb => (cb.checked = false));
        updateAddToCartButton();
        updateSelectAllButtonText();
      });
    }, 10);
  }

  function handleSelectAllToggle() {
  const anySelected = Array.from(checkboxes).some(cb => cb.checked && !cb.disabled);

  checkboxes.forEach(cb => {
    const row = cb.closest('.schema-product-row');

    // Skip alternate items (don't auto-select them)
    if (row && row.classList.contains('rr--schema-alternate')) {
      return;
    }

    if (!cb.disabled) {
      cb.checked = !anySelected;
    }
  });

  updateAddToCartButton();
  updateSelectAllButtonText();
}


  // === Bind Events ===

  selectAllButton?.addEventListener('click', handleSelectAllToggle);

  if (addToCartButton) {
    const clonedBtn = addToCartButton.cloneNode(true);
    addToCartButton.parentNode.replaceChild(clonedBtn, addToCartButton);
    clonedBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleGroupAdd();
    });
    addToCartButton = clonedBtn;
  }

  checkboxes.forEach(cb => {
    cb.addEventListener('change', () => {
      updateAddToCartButton();
      updateSelectAllButtonText();
    });
  });

  singleAddToCartButtons.forEach(button => {
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    newButton.addEventListener('click', () => handleSingleAdd(newButton));
  });

  document.addEventListener('cart:updated', updateBasketCounts);

  // === Initial Setup ===
  updateBasketCounts();
  updateAddToCartButton();
  updateSelectAllButtonText();
});

// === Schema Quantity Button Handler ===
document.querySelectorAll('.schema-qty').forEach(qtyContainer => {
  const input = qtyContainer.querySelector('.rr--quantity__input');
  const plusButton = qtyContainer.querySelector('.rr--quantity__button[name="plus"]');
  const minusButton = qtyContainer.querySelector('.rr--quantity__button[name="minus"]');

  if (!input || !plusButton || !minusButton) return;

  plusButton.addEventListener('click', (e) => {
    e.preventDefault();
    let current = parseInt(input.value || 0, 10);
    input.value = current + 1;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  minusButton.addEventListener('click', (e) => {
    e.preventDefault();
    let current = parseInt(input.value || 0, 10);
    input.value = Math.max(1, current - 1);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
});
